<app-main-base [useGrid]="false"
    [isMobile]="isMobile"
    (back)="goBack()">
    <span mainTitle>{{'PRINTERS.GENERAL.TITLE' | translate}}</span>

    <ng-container mainActions>
        <app-action-btn 
            (click)="save()">
            Salva
        </app-action-btn>
    </ng-container>

    <div mainHeaderExtra>
        <nav mat-tab-nav-bar [tabPanel]="tabPanel" color="primary">
            <a mat-tab-link 
               (click)="activeTab = 'fiscal'" 
               [active]="activeTab === 'fiscal'">
               {{'PRINTERS.TABS_LABEL.FISCAL' | translate}}
            </a>
            <a mat-tab-link 
               (click)="activeTab = 'orders'" 
               [active]="activeTab === 'orders'">
               {{'PRINTERS.TABS_LABEL.ORDERS' | translate}}
            </a>
        </nav>
    </div>

    <div mainBody>
        <mat-tab-nav-panel #tabPanel>
            <div class="tw-grid tw-w-full tw-gap-4 tw-items-stretch tw-pb-1"
                [ngClass]="isMobile ? 'tw-grid-cols-1' : 'lg:tw-grid-cols-2'">
                @switch (activeTab) {
                    @case ('fiscal') {
                        <app-fiscal-settings />
                    }
                    @case ('orders') {
                        <app-order-settings />
                    }
                }
            </div>
        </mat-tab-nav-panel>
    </div>
</app-main-base>
